import Vue from 'vue'
import App from './CorporateValues.vue'

Vue.config.productionTip = false

Vue.directive('visible', function(el, binding) {
	el.style.visibility = !binding.value ? 'visible' : 'hidden';
});

new Vue({
  render: h => h(App),
  data: {imagePrefix: ''},
    beforeMount: function () {
        this.imagePrefix = this.$el.attributes['data-image-prefix'].value;
    },
}).$mount('#corporate-values')
